import frequencyPeriods from './frequencyPeriods';

const mxTypes = [
  frequencyPeriods.DAILY,
  frequencyPeriods.WEEKLY,
  frequencyPeriods.BEWEEKLY,
  frequencyPeriods.MONTHLY,
];

const auTypes = [
  frequencyPeriods.WEEKLY,
  frequencyPeriods.FORTNIGHTLY,
  frequencyPeriods.MONTHLY,
  // frequencyPeriods.QUARTERLY, // probably should be enabled later
];

export default COUNTRY === 'AU' ? auTypes : mxTypes;
